import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./AuthContext";
import { BottomNav, Page } from "./components/Layout";
import HomePage from "./pages/Home";
import AuthPage from "./pages/Auth";
import PrenotaPage from "./pages/Prenota";
import CorsiPage from "./pages/Corsi";
import ProfiloPage from "./pages/Profilo";
import AdminPage from "./pages/Admin";
import TeacherDashboard from "./pages/TeacherDashboard";
import StudentDashboard from "./pages/StudentDashboard";
import AcademyPublic from "./pages/AcademyPublic";
import TricoPage from "./pages/Tricopigmentazione";
import ReferralPage from "./pages/Referral";
import { FlashNew, FlashEdit, FlashLed, FlashDetail, FlashDayList, ProfileComplete, VetrinaSuccess } from "./pages/Flash";
import ImpostaPassword from "./pages/ImpostaPassword";
import { PasswordDimenticata, ResetPassword, AnnullaCancellazione, CancellazioneAccountRichiesta, EliminaAccount, EliminaAccountConferma } from "./pages/PasswordReset";
import { PrivacyPolicy, TerminiServizio } from "./pages/Legal";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function InstallPrompt() {
  const { user } = useAuth();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const h = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  useEffect(() => {
    const visits = Number(localStorage.getItem("mas_visits") || 0) + 1;
    localStorage.setItem("mas_visits", visits);
    if ((user || visits >= 2) && !localStorage.getItem("mas_installed_dismiss")) setShow(true);
  }, [user]);
  if (!show || !deferred) return null;
  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 max-w-md mx-auto card p-4 flex items-center justify-between">
      <span className="text-sm font-medium">Aggiungi MAS al telefono</span>
      <div className="flex gap-2">
        <button data-testid="pwa-install" onClick={() => { deferred.prompt(); setShow(false); }} className="btn-primary text-xs py-1.5 px-3">Installa</button>
        <button onClick={() => { setShow(false); localStorage.setItem("mas_installed_dismiss", "1"); }} className="text-xs text-gray-400 px-2">Chiudi</button>
      </div>
    </div>
  );
}

function NotFound() {
  return (
    <Page>
      <div className="text-center pt-20" data-testid="not-found">
        <div className="logo-mas text-5xl mb-4">MAS</div>
        <h1 className="serif text-2xl">Contenuto non disponibile</h1>
        <p className="text-sm text-gray-500 mt-2">La pagina che cerchi non esiste o è stata rimossa.</p>
        <a href="/" className="btn-primary inline-block mt-6" data-testid="notfound-home">Torna alla Home</a>
      </div>
    </Page>
  );
}

function Shell() {
  const loc = useLocation();
  const { user } = useAuth();
  const hideNav = ["/payment/"].some((p) => loc.pathname.startsWith(p)) || loc.pathname === "/imposta-password";
  if (user && user.must_change_password && loc.pathname !== "/imposta-password") {
    return <Navigate to="/imposta-password" replace />;
  }
  return (
    <>
      <Routes>
        <Route path="/imposta-password" element={<ImpostaPassword />} />
        <Route path="/password-dimenticata" element={<PasswordDimenticata />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/annulla-cancellazione" element={<AnnullaCancellazione />} />
        <Route path="/cancellazione-account-richiesta" element={<CancellazioneAccountRichiesta />} />
        <Route path="/elimina-account" element={<EliminaAccount />} />
        <Route path="/elimina-account/conferma" element={<EliminaAccountConferma />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/termini" element={<TerminiServizio />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/registrati" element={<AuthPage mode="register" />} />
        <Route path="/accedi" element={<AuthPage mode="login" />} />
        <Route path="/prenota" element={<PrenotaPage />} />
        <Route path="/tricopigmentazione" element={<TricoPage />} />
        <Route path="/invita" element={<ReferralPage />} />
        <Route path="/corsi" element={<CorsiPage />} />
        <Route path="/corsi/:cid" element={<CorsiPage />} />
        <Route path="/profilo" element={<ProfiloPage />} />
        <Route path="/profilo/completa" element={<ProfileComplete />} />
        <Route path="/flash-day" element={<FlashDayList />} />
        <Route path="/flash/new" element={<FlashNew />} />
        <Route path="/flash/led" element={<FlashLed />} />
        <Route path="/vetrina/success" element={<VetrinaSuccess />} />
        <Route path="/flash/:id/edit" element={<FlashEdit />} />
        <Route path="/flash/:id" element={<FlashDetail />} />
        <Route path="/corso/:id" element={<CorsiPage />} />
        <Route path="/academy" element={<AcademyPublic />} />
        <Route path="/academy/:cid" element={<AcademyPublic />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/docente" element={<TeacherDashboard />} />
        <Route path="/allievo" element={<StudentDashboard />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideNav && <BottomNav />}
      <InstallPrompt />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}
